import React from 'react';

import { useTranslation } from 'app/lang';
import { getBrandLogo } from 'app/lib/brand';
import { Theme, useTheme } from 'app/lib/theme';

import dictionary from './UnknownError.dictionary.json';

import styles from './UnknownError.module.scss';

const UnknownError = () => {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const logo = getBrandLogo(theme === Theme.DARK ? Theme.LIGHT : Theme.DARK);

  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <div aria-hidden
             className={styles.logoBackground} />
        <img src={logo}
             className={styles.logoImage}
             alt={t(dictionary.logo)} />
      </div>
      <div>
        <h1 className={styles.title}>{t(dictionary.title)}</h1>
        <h3 className={styles.subtitle}>{t(dictionary.subtitle)}</h3>
        <ul className={styles.list}>
          <li data-id="1">
            <span>{t(dictionary.pageTitle)}</span>
            {t(dictionary.pageDescription)}
          </li>
          <li data-id="2">
            <span>{t(dictionary.internetTitle)}</span>
            {t(dictionary.internetDescription)}
          </li>
          <li data-id="3">
            <span>{t(dictionary.siteTitle)}</span>
            {t(dictionary.siteDescription)}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default UnknownError;
